import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type CreateInvoiceEmailDraftMutationVariables = Types.Exact<{
  input: Types.CreateInvoiceEmailDraftInput;
}>;


export type CreateInvoiceEmailDraftMutation = { __typename?: 'Mutation', createInvoiceEmailDraft: { __typename?: 'CreateInvoiceEmailDraftPayload', webLink?: string | null, draftId?: string | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type SendInvoiceEmailMutationVariables = Types.Exact<{
  input: Types.SendInvoiceEmailInput;
}>;


export type SendInvoiceEmailMutation = { __typename?: 'Mutation', sendInvoiceEmail: { __typename?: 'SendInvoiceEmailPayload', sent: boolean, draftWebLink?: string | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };


export const CreateInvoiceEmailDraftDocument = new TypedDocumentString(`
    mutation CreateInvoiceEmailDraft($input: CreateInvoiceEmailDraftInput!) {
  createInvoiceEmailDraft(input: $input) {
    webLink
    draftId
    errors {
      code
      message
    }
  }
}
    `);
export const SendInvoiceEmailDocument = new TypedDocumentString(`
    mutation SendInvoiceEmail($input: SendInvoiceEmailInput!) {
  sendInvoiceEmail(input: $input) {
    sent
    draftWebLink
    errors {
      code
      message
    }
  }
}
    `);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    CreateInvoiceEmailDraft: build.mutation<CreateInvoiceEmailDraftMutation, CreateInvoiceEmailDraftMutationVariables>({
      query: (variables) => ({ document: CreateInvoiceEmailDraftDocument, variables })
    }),
    SendInvoiceEmail: build.mutation<SendInvoiceEmailMutation, SendInvoiceEmailMutationVariables>({
      query: (variables) => ({ document: SendInvoiceEmailDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useCreateInvoiceEmailDraftMutation, useSendInvoiceEmailMutation } = injectedRtkApi;
